import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link, useNavigate } from "react-router-dom";

import DataTable from "react-data-table-component";
import { customTableStyles, deleteConfirmation, loadingConfirmation } from "../../utils";
import { Button, Form } from "react-bootstrap";
import EditCompanyModal from './edit';
import AddCompanyModal from './Add';
import ViewModal from './View';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useChangeStatusCompanyMutation, useGetCompanyQuery, useRemoveCompanyMutation } from '../../redux/services/companyService';
import CustomPagination from '../../components/CustomPagination';


const CompaniesPage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)

    const [removeRequest] = useRemoveCompanyMutation()
    const [statusRequest] = useChangeStatusCompanyMutation()

    const { data: data2, isFetching, refetch } = useGetCompanyQuery({pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}`
})
    const drivers = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    console.log('af', total)


    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    // const data = [];

    return (
        <>
            <PageHeader name="Companies" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Company
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    {/*<div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            name: 'Company Name',
                                            selector: row => row.company_name,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('company_name')}
                                                >
                                                    {searchBy == 'company_name' ? <b className='text-success'>Company Name</b> : 'Company Name'}
                                                </span>
                                            ),
                                            width: '160px'
                                        },
                                        {
                                            name: 'User First Name',
                                            selector: row => row.first_name,
                                            sortable: true,
                                            width: '160px',
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('first_name')}
                                                >
                                                    {searchBy == 'first_name' ? <b className='text-success'>User First Name</b> : 'User First Name'}
                                                </span>
                                            ),
                                        },
                                        {
                                            name: 'Email',
                                            selector: row => row.email,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('email')}
                                                >
                                                    {searchBy == 'email' ? <b className='text-success'>Email</b> : 'Email'}
                                                </span>
                                            ),
                                            width: '160px'
                                        },
                                        {
                                            name: 'Phone',
                                            selector: row => row.phone,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('phone')}
                                                >
                                                    {searchBy == 'phone' ? <b className='text-success'>Phone</b> : 'Phone'}
                                                </span>
                                            ),
                                        },
                                        {
                                            name: 'Country',
                                            selector: row => row.country,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('country')}
                                                >
                                                    {searchBy == 'country' ? <b className='text-success'>Country</b> : 'Country'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'City',
                                            selector: row => row.city,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('city')}
                                                >
                                                    {searchBy == 'city' ? <b className='text-success'>City</b> : 'City'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'State',
                                            selector: row => row.state,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('state')}
                                                >
                                                    {searchBy == 'state' ? <b className='text-success'>State</b> : 'State'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'Status',
                                            cell: (row) => (
                                                <div className="form-switch">
                                                    {/* {row?.is_application_editable} */}
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        defaultChecked={row.status == 0 ? false : true}
                                                        readOnly
                                                        onClick={() => loadingConfirmation(() => statusRequest({ id: row?.id, status: row?.status == 0 ? 1 : 0 }), 'Chnage Status', row?.status == 0 ? 1 : 0)}
                                                    />
                                                </div>
                                            ),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">

                                                        <a
                                                            aria-label="view"
                                                            onClick={handleView.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-fill" />
                                                        </a>
                                                        <button
                                                            aria-label="edit"
                                                            onClick={handleEdit.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        {/*<a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light d-none"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>*/}
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '150px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>

                        {isShow && (
                            <AddCompanyModal
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}
                        {/* <AddCompanyModal
                            show={isShow}
                            handleClose={() => setIsShow(false)}
                        /> */}
                        {/* <EditCompanyModal
                            show={isEdit}
                            handleClose={() => setIsEdit(false)}
                        /> */}

                        {isView && (
                            <ViewModal
                                show={isView}
                                handleClose={() => {
                                    setIsView(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default CompaniesPage;